/*
 * Authors: mariushirjanu
 * Created: 27/03/2023
 */
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'underscore';
import { BILLINGTYPE_CENTRAL, BILLINGTYPE_LOCAL } from '../../../../shared/services/billing/billing-data.service';
import { IAddressData, IBillingType, IContactModel } from './base-order-entry-location-to.service';
import { IContact } from '../../../../../type_definitions/datatypes';

@Injectable()
export class OrderEntryLocationService {

  constructor() {
    /***/
  }

  public billingTypes():IBillingType[] {
    return [
      {
        id: BILLINGTYPE_LOCAL,
        name: 'ORDERENTRY.INVOICE.LOCAL_BILLING'
      },
      {
        id: BILLINGTYPE_CENTRAL,
        name: 'ORDERENTRY.INVOICE.CENTRAL_BILLING'
      }
    ];
  }

  public billingType(id:string):IBillingType {
    return _.findWhere(this.billingTypes(), { id });
  }

  public updateLocationData(addressModel:IAddressData, form?:UntypedFormGroup, forceUpdate?:boolean):void {
    if (!addressModel || !addressModel.location) {
      return;
    }

    if (forceUpdate || !addressModel.company) {
      // this mimics the formatting of locations
      addressModel.company = addressModel.location?.companyRegisteredName || addressModel.location?.subCompany?.name || addressModel.location?.companyCountry?.company?.name;
    }
    if (forceUpdate || !addressModel.address) {
      addressModel.address = addressModel.location?.address;
    }
    if (forceUpdate || !addressModel.zip) {
      addressModel.zip = addressModel.location?.zipCode;
    }
    if (forceUpdate || !addressModel.city) {
      addressModel.city = addressModel.location?.city;
    }
    if (forceUpdate || !addressModel.state) {
      addressModel.state = addressModel.location?.state;
    }
    if (forceUpdate || !addressModel.country) {
      addressModel.country = addressModel.location?.companyCountry?.country;
    }
    if (forceUpdate || !addressModel.tax) {
      addressModel.tax = addressModel.location?.vatNumber;
    }
    if (forceUpdate || !addressModel.office) {
      addressModel.office = addressModel.location?.office;
    }
    if (forceUpdate || !addressModel.invoiceEmailAddress) {
      addressModel.invoiceEmailAddress = addressModel.location?.invoiceEmailAddress;
    }

    // reactive form update
    if (form) {
      form.patchValue({
        company: addressModel.company,
        address: addressModel.address,
        zip: addressModel.zip,
        city: addressModel.city,
        state: addressModel.state,
        country: addressModel.country,
        tax: addressModel.tax,
        office: addressModel.office,
        invoiceEmailAddress: addressModel.invoiceEmailAddress
      });
    }
  }

  public formatContact(contact:IContact):IContactModel {
    if(!contact){
      return;
    }

    return {
      contact,
      directPhone: contact.directPhone,
      email: contact.email,
      fullName: contact.fullName
    };
  }
}